/**
 * @generated SignedSource<<ab021829a961f2d48eb36d1c8a39a087>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateRecruitDetailsInput = {
  clientMutationId?: string | null;
  description?: string | null;
  goal?: number | null;
  incentive?: string | null;
  incentivePoints?: number | null;
  incentiveType?: string | null;
  name?: string | null;
  recruitId: string;
  remindersEnabled?: boolean | null;
  settings?: any | null;
};
export type RecruitNameModal_updateRecruitDetails_Mutation$variables = {
  input: UpdateRecruitDetailsInput;
};
export type RecruitNameModal_updateRecruitDetails_Mutation$data = {
  readonly updateRecruitDetails: {
    readonly recruit: {
      readonly description: string | null;
      readonly id: string;
      readonly name: string | null;
    } | null;
  } | null;
};
export type RecruitNameModal_updateRecruitDetails_Mutation = {
  response: RecruitNameModal_updateRecruitDetails_Mutation$data;
  variables: RecruitNameModal_updateRecruitDetails_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateRecruitDetailsPayload",
    "kind": "LinkedField",
    "name": "updateRecruitDetails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitNode",
        "kind": "LinkedField",
        "name": "recruit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RecruitNameModal_updateRecruitDetails_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecruitNameModal_updateRecruitDetails_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a15b115512aea7aa54d3203e38cdb141",
    "id": null,
    "metadata": {},
    "name": "RecruitNameModal_updateRecruitDetails_Mutation",
    "operationKind": "mutation",
    "text": "mutation RecruitNameModal_updateRecruitDetails_Mutation(\n  $input: UpdateRecruitDetailsInput!\n) {\n  updateRecruitDetails(input: $input) {\n    recruit {\n      id\n      name\n      description\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "750937629454331564e22ef209f706d3";

export default node;
